import { render, staticRenderFns } from "./Otpravki.vue?vue&type=template&id=b506c0ce&scoped=true&"
import script from "./Otpravki.vue?vue&type=script&lang=js&"
export * from "./Otpravki.vue?vue&type=script&lang=js&"
import style0 from "./Otpravki.vue?vue&type=style&index=0&id=b506c0ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b506c0ce",
  null
  
)

export default component.exports